import React from "react";

const BreadCrumbNav = () => {
    return (
        <div className="flex flex-row justify-start items-center"></div>
    )
}

export default BreadCrumbNav
